import { GetIdeaResponse, PostIdeaType } from '@orbit/api-types'
import { getDeviceContext } from '@lib/analytics'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { createTripMutation } from './createTripCrudResource'

export const useCreateIdea = createTripMutation<
	GetIdeaResponse,
	{ tripId: string; ideaData: PostIdeaType }
>({
	mutationFn: async ({ ideaData }) => {
		const response = await api.post<GetIdeaResponse>(`/ideas`, { ...ideaData, analytics: getDeviceContext() })
		return response.data
	},
	invalidate: ({ tripId }) => [queryKeys.ideas(tripId)],
})
